import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const UserFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onAddUser,
  totalUsers,
  selectedCount 
}) => {
  const roleOptions = [
    { value: '', label: 'Todos los roles' },
    { value: 'admin', label: 'Administrador' },
    { value: 'operator', label: 'Operador' },
    { value: 'auditor', label: 'Auditor' }
  ];

  const statusOptions = [
    { value: '', label: 'Todos los estados' },
    { value: 'active', label: 'Activo' },
    { value: 'inactive', label: 'Inactivo' },
    { value: 'blocked', label: 'Bloqueado' }
  ];

  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const hasActiveFilters = filters?.search || filters?.role || filters?.status;

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={20} className="text-primary" />
            <h2 className="text-lg font-semibold text-foreground">Administración de Usuarios</h2>
          </div>
          <div className="text-sm text-muted-foreground">
            {totalUsers} usuarios totales
            {selectedCount > 0 && (
              <span className="ml-2 text-primary font-medium">
                • {selectedCount} seleccionados
              </span>
            )}
          </div>
        </div>
        
        <Button
          variant="default"
          onClick={onAddUser}
          iconName="UserPlus"
          iconPosition="left"
          iconSize={16}
        >
          Agregar Usuario
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Buscar por nombre o email..."
            value={filters?.search}
            onChange={(e) => handleInputChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>
        
        <Select
          placeholder="Filtrar por rol"
          options={roleOptions}
          value={filters?.role}
          onChange={(value) => handleInputChange('role', value)}
        />
        
        <Select
          placeholder="Filtrar por estado"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleInputChange('status', value)}
        />
      </div>
      {hasActiveFilters && (
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Filter" size={14} />
            <span>Filtros activos aplicados</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={14}
          >
            Limpiar Filtros
          </Button>
        </div>
      )}
    </div>
  );
};

export default UserFilters;